import type { TagDefinition } from "../api/portfolio";

interface Props {
  selected: string;
  onChange: (dimension: string) => void;
  customTags?: TagDefinition[];
  analysisMode?: "ctg" | "ops";
  onAnalysisModeChange?: (mode: "ctg" | "ops") => void;
}

const BUILTIN_OPTIONS = [
  { key: "all", label: "All" },
  { key: "tech", label: "Technology" },
  { key: "region", label: "Region" },
  { key: "lifecycle", label: "Lifecycle" },
  { key: "capacity_tier", label: "Capacity" },
  { key: "portfolio", label: "Portfolio" },
  { key: "profile_source", label: "Profile source" },
];

export function GroupBySelector({
  selected,
  onChange,
  customTags,
  analysisMode,
  onAnalysisModeChange,
}: Props) {
  const options = [
    ...BUILTIN_OPTIONS,
    ...(customTags ?? []).map((t) => ({
      key: t.tag_key,
      label: t.display_name || t.tag_key,
    })),
  ];

  return (
    <div className="flex items-center justify-between flex-wrap gap-y-2">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-body-sm text-text-muted mr-1">Group by:</span>
        {options.map((opt) => (
          <button
            key={opt.key}
            onClick={() => onChange(opt.key)}
            className={`px-3 py-1.5 rounded-full text-body-sm transition-colors ${
              selected === opt.key
                ? "bg-quantum-500/20 text-quantum-400 ring-1 ring-quantum-500/40"
                : "bg-surface-600 text-text-secondary hover:bg-surface-500 hover:text-text-primary"
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {analysisMode && onAnalysisModeChange && (
        <div className="flex items-center bg-surface-600 rounded-full p-0.5">
          <button
            onClick={() => onAnalysisModeChange("ctg")}
            title="Total lifecycle benefits vs fossil baseline — all phases"
            className={`px-3 py-1.5 text-xs font-medium rounded-full transition-colors ${
              analysisMode === "ctg"
                ? "bg-quantum-500/20 text-quantum-400 ring-1 ring-quantum-500/40"
                : "text-text-muted hover:text-text-secondary"
            }`}
          >
            Cradle to Grave
          </button>
          <button
            onClick={() => onAnalysisModeChange("ops")}
            title="Operational displacement benefits only — excludes manufacturing"
            className={`px-3 py-1.5 text-xs font-medium rounded-full transition-colors ${
              analysisMode === "ops"
                ? "bg-amber-500/20 text-amber-400 ring-1 ring-amber-500/40"
                : "text-text-muted hover:text-text-secondary"
            }`}
          >
            Operations
          </button>
        </div>
      )}
    </div>
  );
}
